import { Paper, Typography } from "@mui/material";
import Layout from "../../components/Layout";
import { useT } from "../../i18n";
import AbfallartenDataTable from "../../components/abfallarten/AbfallartenDataTable";
import ErrorAlert from "../../components/ErrorAlert";
import { notPermitted } from "../../errors";
import React from "react";
import Guard from "../../components/Guard";

export default function AbfallartenListe() {
  const { t } = useT("customer");
  const limit = parseInt(localStorage.getItem("abfallartenLimit") ?? "25", 10);
  return (
    <Layout title="Abfallarten" showTitleInNav={false}>
      <Guard
        permission={"abfallart:list"}
        fallback={<ErrorAlert error={notPermitted()} />}
      >
        <Paper
          elevation={1}
          sx={{ marginTop: 2, padding: 3, marginLeft: 2, marginRight: 2 }}
        >
          <Typography variant="h5">Abfallarten</Typography>
          <AbfallartenDataTable limit={limit} />
        </Paper>
      </Guard>
    </Layout>
  );
}
